module.exports = __webpack_public_path__ + "img/eat.272734b3.png";